// src/pages/Logs.jsx
import React, { useState } from 'react';
import './Logs.css';

const BASE_URL = process.env.REACT_APP_OFFSETBRIDGE_APP_URL;

export default function Logs() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/logs?key=${encodeURIComponent(password)}`);

      if (!response.ok) {
        if (response.status === 403) {
          setError('Invalid password');
        } else {
          setError('Failed to fetch logs');
        }
        setLoading(false);
        return;
      }

      // Get the file content
      const blob = await response.blob();

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'api_requests.log';
      document.body.appendChild(a);
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      setPassword('');
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError('An error occurred. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="logs-container">
      <div className="logs-card">
        <h1>Access Logs</h1>
        <p className="logs-subtitle">Enter the password to download the API request logs</p>

        <form onSubmit={handleSubmit} className="logs-form">
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              className="logs-input"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button
            type="submit"
            disabled={loading || !password}
            className="logs-submit-btn"
          >
            {loading ? 'Loading...' : 'Download Logs'}
          </button>
        </form>
      </div>
    </div>
  );
}
